/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 * Note: vue-clickaway n'est plus compatible avec Vue 3
 * Utiliser @vueuse/core ou une directive personnalisée à la place
 */

const GlobalDirectives = {
  install(app) {
    // Vue-clickaway n'est plus compatible avec Vue 3
    // Vous pouvez utiliser @vueuse/onClickOutside ou créer une directive personnalisée
    // Exemple de directive personnalisée:
    app.directive("click-outside", {
      mounted(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unmounted(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    });
  },
};

export default GlobalDirectives;
